import React from 'react'
import { Button } from '@mc/design-system'
import { usePrimaryCta, useAnnualPass } from '@mc/growth'
import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import CTA from 'components/CTA'
import { trackPurchaseClick, trackAllImmersionsLink } from '../../events'
import classes from './LiveCTAs.module.scss'

export const LiveCTAs = ({ slug }: { slug: string }) => {
  const { t } = useTranslation('@mc/next')
  const { ctaCopy, ctaHref } = usePrimaryCta()
  const annualPass = useAnnualPass()

  return (
    <>
      <div className={`${classes.ctaContainer} d-flex`}>
        <CTA
          className={classes.cta}
          fullWidth
          onClick={() =>
            trackPurchaseClick({
              slug,
              isLive: true,
              action: ctaCopy,
              href: ctaHref,
              annualPass,
            })
          }
          trackPurchaseClick={false}
        />
        <Button
          render={<a href={paths.sessions()} />}
          kind='tertiary'
          className={classes.cta}
          fullWidth
          onClick={() =>
            trackAllImmersionsLink(
              t('sessions.campHeroCTAs.hubPage'),
              slug,
              false,
            )
          }
        >
          {t('sessions.campHeroCTAs.hubPage')}
        </Button>
      </div>
    </>
  )
}
